var _mask, _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoText = function SvgLogoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apechain-logo",
    viewBox: "0 0 595 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_66_5899",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 204,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 204,
    rx: 1,
    fill: "#0054FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 204,
    rx: 1,
    stroke: "#0054FA",
    strokeWidth: 14,
    mask: "url(#path-1-inside-1_66_5899)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3348 48H99.0348L112.385 159H94.8348L92.8848 134.85H83.5848L81.6348 159H64.9848L78.3348 48ZM86.5848 97.35L84.7848 120.15H91.6848L89.7348 97.35L88.3848 78.15H87.9348L86.5848 97.35ZM149.168 159H131.318V48H154.718C167.468 48 175.268 55.5 175.268 69V96.3C175.268 109.65 167.468 117.15 154.718 117.15H149.168V159ZM149.318 103.8H153.218C156.218 103.8 157.418 101.1 157.418 96.3V69C157.418 64.05 156.218 61.35 153.218 61.35H149.318V103.8ZM195.829 159V48H230.629V62.7H213.679V95.55H228.829V110.25H213.679V144.3H230.629V159H195.829ZM292.098 114V137.85C292.098 152.25 284.898 160.2 271.248 160.2C257.598 160.2 249.198 152.25 249.198 137.85V69.15C249.198 54.75 257.598 46.8 271.248 46.8C284.898 46.8 292.098 54.75 292.098 69.15V92.1H275.298V67.8C275.298 63.15 274.098 60.45 271.248 60.45C268.248 60.45 267.048 63.15 267.048 67.8V139.35C267.048 143.85 268.248 146.55 271.248 146.55C274.098 146.55 275.298 143.85 275.298 139.35V114H292.098ZM340.441 159V110.55H330.841V159H312.841V48H330.841V95.4H340.441V48H358.291V159H340.441ZM390.493 48H411.193L424.543 159H406.993L405.043 134.85H395.743L393.793 159H377.143L390.493 48ZM398.743 97.35L396.943 120.15H403.843L401.893 97.35L400.543 78.15H400.093L398.743 97.35ZM443.476 159V48H461.476V159H443.476ZM502.135 48L511.585 103.65H511.885V48H527.335V159H511.435L498.835 94.05H498.535V159H483.085V48H502.135Z",
    fill: "white"
  })));
};
export default SvgLogoText;